import script from "./CourseEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseEdit.vue?vue&type=script&setup=true&lang=js"

import "./CourseEdit.vue?vue&type=style&index=0&id=2eb2da6b&scoped=true&lang=css"

import exportComponent from "/home/kuzma/www/barberteam/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2eb2da6b"]])

export default __exports__